import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
export default class DraftsListState {
  constructor() {
    _defineProperty(this, "loading", false);
    _defineProperty(this, "cache", []);
  }
  deleteDraft(draft) {
    if (!window.confirm(app.translator.trans('fof-drafts.forum.dropdown.alert'))) return;
    this.loading = true;
    draft.delete().then(() => {
      var _app$composer$changed, _app$composer;
      if (app.composer.body && app.composer.draft && app.composer.draft.id() === draft.id() && !((_app$composer$changed = (_app$composer = app.composer).changed) != null && _app$composer$changed.call(_app$composer))) {
        app.composer.hide();
      }
      this.loading = false;
      m.redraw();
    });
  }
  scheduleDraft(draft) {
    if (!app.forum.attribute('canScheduleDrafts') || !app.forum.attribute('drafts.enableScheduledDrafts')) return;

    // Lazy load ScheduleDraftModal
    import(/* webpackChunkName: 'forum/components/ScheduleDraftModal', webpackMode: 'lazy-once' */ '../components/ScheduleDraftModal').then(module => {
      app.modal.show(module.default, {
        draft
      });
    });
  }
  showComposer(draft) {
    if (this.loading) return;
    return new Promise(async resolve => {
      let componentClass;
      switch (draft.type()) {
        case 'privateDiscussion':
          // Use lazy loading for byobu extension
          try {
            const byobuModule = await flarum.reg.asyncModuleImport('ext:fof/byobu/forum/pages/discussions/PrivateDiscussionComposer');
            componentClass = byobuModule.default;
          } catch (e) {
            console.error('Failed to load byobu composer:', e);
            return;
          }
          break;
        case 'reply':
          // Lazy load ReplyComposer
          const replyModule = await flarum.reg.asyncModuleImport('flarum/forum/components/ReplyComposer');
          componentClass = replyModule.default;
          break;
        default:
          // Lazy load DiscussionComposer
          const discussionModule = await flarum.reg.asyncModuleImport('flarum/forum/components/DiscussionComposer');
          componentClass = discussionModule.default;
      }
      const data = draft.compileData();

      // Load composer asynchronously
      await app.composer.load(componentClass, data);
      app.composer.show();
      Object.assign(app.composer.fields, data.fields);
      return resolve(app.composer);
    });
  }
  load() {
    if (app.cache.draftsLoaded) {
      return;
    }
    this.loading = true;
    m.redraw();
    app.store.find('drafts').then(() => app.cache.draftsLoaded = true, () => {}).then(() => {
      this.loading = false;
      m.redraw();
    });
  }
}
flarum.reg.add('fof-drafts', 'forum/states/DraftsListState', DraftsListState);flarum.reg.addChunkModule('519', '297', 'fof-drafts', 'forum/components/ScheduleDraftModal');